import { ExpenseReturnReason } from '../enums/expense-return-reason.enum';

/**
 * Motivo → clave de traducción.
 *
 * Las mismas claves alimentan el desplegable de la revisión y el detalle del
 * gasto, así que no pueden desincronizarse entre lo que elige operaciones y lo
 * que se lee después.
 */
export const EXPENSE_RETURN_REASON_LABEL: Readonly<
  Record<ExpenseReturnReason, string>
> = {
  'blurry-photo': 'expenses.return_reason.blurry_photo',
  'missing-photo': 'expenses.return_reason.missing_photo',
  'wrong-photo': 'expenses.return_reason.wrong_photo',
  'wrong-amount': 'expenses.return_reason.wrong_amount',
  'wrong-category': 'expenses.return_reason.wrong_category',
  'wrong-date': 'expenses.return_reason.wrong_date',
};
